import { useQuery } from "@tanstack/react-query";
import { getUserPermissions } from "@/services/api.js";
import { useAuthStore } from "@";

const FIVE_MINUTES = 5 * 60 * 1000;

// Hook for fetching user permissions from API using React Query.
// Overrides the global staleTime so permissions actually refresh during a session.
export const useUserPermissionsQuery = () => {
  const user = useAuthStore((state) => state.user);

  return useQuery({
    queryKey: ["user-permissions", user?.id],
    queryFn: async () => {
      const { data } = await getUserPermissions();
      return data;
    },
    enabled: !!user?.id,
    initialData: user?.userPermissions,
    // Treat the seeded value as stale-from-epoch so refetchOnMount/refetchOnWindowFocus
    // actually fire — without this, React Query treats initialData as freshly fetched.
    initialDataUpdatedAt: 0,
    staleTime: FIVE_MINUTES,
    refetchOnWindowFocus: "always",
    refetchOnMount: "always",
    refetchInterval: FIVE_MINUTES,
    retry: false,
  });
};
